import ContratArticle from '@/generated/classes/ContratArticle';
export default class ContratArticleExtend  extends ContratArticle {
  constructor() {
    super();
  }
}
